import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/Layout';
import PageBody from '../components/PageBody';
import { getScripts } from '../utils/pageUtils';
import PageHead from '../components/Head/PageHead';

export default ({ data, location, pageContext }) => {
  const { meta } = data.page;
  const { parsedBody } = pageContext;
  const { bodyStartScripts, bodyEndScripts } = getScripts(meta);
  return (
    <React.Fragment>
      <PageHead meta={meta} body={parsedBody} />
      <div dangerouslySetInnerHTML={{ __html: bodyStartScripts }}></div>
      <Layout location={location}>
        <PageBody blocks={parsedBody} />
      </Layout>
      <div dangerouslySetInnerHTML={{ __html: bodyEndScripts }}></div>
    </React.Fragment>
  );
};

export const query = graphql`
  query($id: String!) {
    page: sanityPage(_id: { eq: $id }) {
      meta: _rawMeta
    }
  }
`;
